import common from './common.lang';
import membership from '~/routes/membership/membership.lang';
import paperwork from '~/routes/paperwork/paperwork.lang';

export default {
  common,
  membership,
  paperwork,
};
